var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { getOnnaDomain } from './domain';
export function fetchRooms(exhibitionId, vrtype) {
    return __awaiter(this, void 0, void 0, function* () { var _res$data$data, _res$data; const domain = getOnnaDomain(vrtype); const url = "https://".concat(domain, "/getRoomData"); const res = yield axios.post(url, { id: exhibitionId }); return (_res$data$data = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data) !== null && _res$data$data !== void 0 ? _res$data$data : res.data; });
}
const roomApi = { fetchRooms };
export default roomApi;
